export var valuesLegendHorizontalAlignment = ["left", "center", "right"];
//# sourceMappingURL=LegendHorizontalAlignment.js.map